import { ref } from 'vue'
import { defineStore } from 'pinia'

/** 应用级 UI 状态 */
export const useAppStore = defineStore('app', () => {
  const sidebarCollapsed = ref(false)
  const alarmBallVisible = ref(true)

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  return { sidebarCollapsed, alarmBallVisible, toggleSidebar }
})
